var render = function (_h,_vm) {var _c=_vm._c;return _c('h3',[_vm._t("default"),(_vm.$slots.suffix)?_c('span',{staticClass:"suffix"},[_vm._v(" "+_vm._s(_vm.$slots.suffix[0].text)+" ")]):_vm._e(),(_vm.$slots.action)?_c('span',{staticClass:"action"},[_vm._t("action")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }